export const createFolder = data => ({
  method: 'POST',
  url: '/nfolders',
  data
});
export const fetchFolders = () => ({
  method: 'GET',
  url: '/nfolders'
});
export const fetchFolder = folderId => ({
  method: 'GET',
  url: `/nfolders/${folderId}`
});
export const folderAction = (folderId, action, data) => ({
  method: 'POST',
  url: `/nfolders/${folderId}/${action}`,
  data
});
